<template>
  <v-card :loading="loading" class="p-12">
    <custom-popup id="gallery" v-model="priceDialog" :cons="{title: 'افزودن قیمت'} " hide-confirm max-width="500">
      <v-card class="p-8">
        <v-text-field v-model="price.name" class="my-2" dense hide-details label="عنوان" outlined/>

        <v-text-field v-model.number="price.time" class="my-2" dense hide-details label="زمان (روز)" outlined
                      type="number"/>

        <price-input v-model.number="price.price" class="my-2" dense label="قیمت" outlined/>

        <v-text-field v-model="price.discount" class="my-2" dense hide-details label="درصد تخفیف" max="100" min="0"
                      outlined type="number"/>

        <v-autocomplete v-model="price.type" :disabled="isEditing" :items="qrTypes" chips
                        clear-icon="mdi-close-circle-outline" clearable dense item-text="name" label="نوع کیوآر"
                        multiple outlined>
          <template v-slot:selection="data">
            <v-chip :input-value="data.selected" close @click="data.select" @click:close="remove(data.item)">
              <v-icon left>{{ data.item.icon }}</v-icon>
              {{ data.item.name }}
            </v-chip>
          </template>

          <template v-slot:item="data">
            <v-list-item-icon>
              <v-icon>{{ data.item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-text="data.item.name"/>
            </v-list-item-content>
          </template>
        </v-autocomplete>

        <v-card-actions>
          <v-btn v-if="!isEditing" :loading="loading" class="btn-sub ms-auto px-8" color="green lighten-3"
                 @click="createPrice">
            افزودن
          </v-btn>

          <v-btn v-else :loading="loading" class="btn-sub ms-auto px-8" color="green lighten-3" @click="updatePrice">
            ویرایش
          </v-btn>
        </v-card-actions>
      </v-card>
    </custom-popup>

    <v-row class="mb-6">
      <v-btn :loading="loading" class="btn-sub px-8" color="green lighten-3" @click="priceDialog=true">
        <v-icon small>mdi-plus</v-icon>
        جدید
      </v-btn>
    </v-row>

    <v-row no-gutters>
      <v-col class="pa-2" col="12" lg="3" md="4" sm="6">
        <v-select v-model="tableProps.length" :items="[10, 25, 50, 100, 200]" clearable dense hide-details
                  label="تعداد نمایش" outlined @change="reloadTable()"/>
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-text-field v-model="tableProps.search" append-icon="mdi-magnify" clear-icon="mdi-close-circle-outline"
                      clearable dense hide-details label="جستجو" outlined @click:append="reloadTable()"
                      @keydown.enter="reloadTable()" @click:clear="clearFilter"/>
      </v-col>
    </v-row>

    <terminal-table
      v-if="isMobile" :currentPage="data.current_page" :datas="data" :getData="getData" :headers="columns"
      :options="tableProps" :pageCount="data.last_page" :perPage="data.per_page" class="col-12"/>

    <data-table v-else :columns="columns" :data="data" :translate="translate">
      <div slot="filters"/>

      <div slot="pagination">
        <pagination v-if="data && data.data" ref="pagination" :data="data" @page="onPagination">
          <template v-slot:per-page>
            <v-select
              v-model="tableProps.length"
              :items="[10, 25, 50, 100, 200]"
              :menu-props="{ offsetY: true }"
              class="ma-2 my-md-0"
              dense
              label="تعداد نمایش"
              outlined
              @change="onPerPage"/>
          </template>
        </pagination>
      </div>
    </data-table>

    <!--    <mixed-table-->
    <!--        :columns="columns"-->
    <!--        :data="data"-->
    <!--        :fetch-data="getData"-->
    <!--        :reload-table="reloadTable"/>-->
  </v-card>
</template>

<script>
import {debounce} from "@/main";
import button from "@/view/pages/button";
import MixedTable from "@/view/components/Table/MixedTable";
import PriceInput from "@/view/pages/uiBeautifier/priceInput";
import {dataTableProps} from "@/main";
import Pagination from "../../content/fragments/pagination";

export default {
  name: "Pricing",

  components: {Pagination, PriceInput, MixedTable},

  data() {
    return {
      loading: false,
      priceDialog: false,
      isEditing: false,
      data: {},
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          isCheckBox: true,
          transform: (val) => {
            return `<input type="checkbox" name="checkID"  data-id="${val.data.id}">`
          },
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
        },
        {
          label: 'عنوان',
          name: 'name',
          primary: true
        },
        {
          label: 'نوع Qr',
          name: 'type',
          transform: (val) => {
            return this.qrTypes.find(x => x.value.toLowerCase() === val.data.type.toLowerCase()).name;
          }
        },
        {
          label: 'زمان',
          name: 'time',
        },
        {
          label: 'قیمت (﷼)',
          name: 'price',
          transform: val => this.$options.filters.currency(val.data.price)
        },
        {
          label: 'درصد تخفیف',
          name: 'discount',
          transform: val => !!val.data.discount ? this.persian(val.data.discount) : '--'
        },
        {
          label: 'وضیعت',
          name: 'status',
          primary: true
        },
        {
          label: 'مدیریت',
          name: 'action',
          component: button,
          handler: this.actions,
          event: "actions",
          meta: {
            buttons: [
              {
                name: 'delete',
                label: 'حذف آگهی',
                icon: 'trash-alt',
                class: 'btn-outline-danger',
                action: this.actions,
                status: 'divar_delete',
              },
              {
                name: 'edit',
                label: 'ویرایش آگهی',
                icon: 'pencil-alt',
                class: 'btn-outline-warning',
                action: this.actions,
                status: 'divar_update',
              },
            ]
          }
        }
      ],
      qrTypes: [],
      price: {
        name: undefined,
        type: undefined,
        product_id: undefined,
        time: undefined,
        price: 0,
        discount: 0,
      },
      wallet_url: process.env.VUE_APP_WALLET,
      translate: dataTableProps.translate,
      tableProps: {
        search: '',
        length: 10,
        column: 'id',
        dir: 'desc',
        page: 1
      }
    }
  },

  mounted() {
    this.getData();
    this.qrTypes = this.getQrTypes();
    this.$nextTick(() => {
      this.getProductIds()
    })
  },

  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          this.getData();
          return true
        case 'sm':
          this.getData();
          return true
        case 'md':
          this.getData();
          return false
        case 'lg':
          this.getData();
          return false
        case 'xl':
          this.getData();
          return false
      }
    },
  },

  watch: {
    priceDialog(value) {
      if (!value)
        this.resetPrice();
    }
  },

  methods: {
    getData(query = this.tableProps) {
      this.loading = true;

      this.$api.get('/v1/pricing/', {
        params: query
      })
        .then(response => {
          this.data = response.data.data;
        })
        .catch(reason => {
          this.$modal.error('خطا', 'در دریافت اطلاعات با خطا مواجه‌ شدیم.');
          console.log(reason.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProductIds() {
      this.loading = true

      this.$api.get(`${this.wallet_url}/product`)
        .then(({data}) => {
          this.qrTypes = this.qrTypes.map(item => {
            return this.fixType(item, data)
          })
        })
        .catch(({response}) => console.error('wallet product get error: ', response))
        .finally(() => this.loading)
    },
    fixType(item, data) {
      let o = new Object(item)
      o.product_id = data.data.find(d => d.name.toLowerCase() === o.value.toLowerCase())._id
      o.icon = `mdi-${o.icon}`
      return o
    },
    remove(item) {
      const index = this.price.type.indexOf(item.value)
      if (index >= 0) this.price.type.splice(index, 1)
    },
    clearFilter() {
      this.$nextTick(() => {
        this.reloadTable()
      })
    },
    onPagination(e) {
      if (e !== this.page) {
        this.tableProps.page = e
        this.$nextTick(() => {
          this.getData()
          window.scrollTo({behavior: "smooth", top: 0, left: 0})
        })
      }
    },
    onPerPage() {
      this.$refs.pagination.last_emit = 1
      window.scrollTo({behavior: "smooth", top: 0, left: 0})
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.tableProps.page = this.data.current_page;
        this.getData(tableProps);
      }, 1000);
    },
    createPrice() {
      this.loading = true;

      let obj = this.price
      obj.product_id = this.qrTypes
        .filter(item => obj.type.includes(item.value))
        .sort((a, b) => a.value.localeCompare(b.value))
        .map(item => item.product_id)

      obj.type.sort((a, b) => a.localeCompare(b))

      this.$api.post('/v1/pricing/', obj)
        .then(response => {
          this.resetPrice();
          this.priceDialog = false;
          this.$modal.success('موفقیت', 'تعرفه موردنظر با موفقیت اضافه شد.');
          this.getData(this.tableProps);
        })
        .catch(reason => {
          this.$modal.error('خطا', 'در ثبت اطلاعات با خطا مواجه‌ شدیم.')
          console.log(reason.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updatePrice() {
      this.loading = true;

      if (!this.price.discount || this.price.discount == null)
        this.price.discount = 0

      this.$api.put(`/v1/pricing/${this.price.id}`, this.price)
        .then(response => {
          this.resetPrice();

          this.priceDialog = false;

          this.$modal.success('موفقیت', 'تعرفه موردنظر با موفقیت ویرایش شد.');

          this.getData();
        })
        .catch(reason => {
          this.$modal.error('خطا', 'در ویرایش اطلاعات با خطا مواجه‌ شدیم.')

          console.log(reason.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    actions(data, type) {
      this.loading = true;

      this[type + 'Action'](data);
    },
    deleteAction(data) {
      this.$api.delete(`/v1/pricing/${data.id}`).then(() => {
        this.$modal.success('موفقیت', 'تعرفه موردنظر با موفقیت حذف شد.');
      }).catch(reason => {
        this.$modal.error('خطا', 'در حذف اطلاعات با خطا مواجه‌ شدیم.');
        console.log(reason.response);
      }).finally(() => {
        this.loading = false;
        this.getData();
      });
    },
    editAction(data) {
      this.isEditing = true;
      this.priceDialog = true;

      this.price = data;
      console.log('data: ', data)

      this.$nextTick(() => {
        this.price.product_id = this.qrTypes.find(item => item.value.toLowerCase() === data.type.toLowerCase()).product_id
        this.loading = false;
      });
    },
    resetPrice() {
      this.isEditing = false;

      this.price = {
        name: undefined,
        type: undefined,
        time: undefined,
        price: undefined
      };
    }
  }
}
</script>

<style scoped>

</style>
